import { z } from 'zod';

export const updateVideoParamsSchema = z.object({
  video_id: z.uuid('Invalid video ID'),
});

export const updateVideoSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters').optional(),
  description: z.string().min(1, 'Description is required').optional(),
  content: z.string().min(1, 'Content is required').optional(),
  duration: z.string().min(1, 'Duration is required').optional(),
  video_url: z.url('Invalid video URL').optional(),
  learning_objectives: z.string().min(1, 'Learning objectives are required').optional(),
  prerequisites: z.string().min(1, 'Prerequisites are required').optional(),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
});

export type UpdateVideoParamsPayload = z.infer<typeof updateVideoParamsSchema>;
export type UpdateVideoPayload = z.infer<typeof updateVideoSchema>;
